<template>
  <div class="app-container">
    <el-form
      :model="pageQuery"
      ref="queryForm"
      :inline="true"
      size="small"
      class="box_form"
    >
      <el-form-item label="发送时间:" prop="time">
        <el-date-picker
          v-model="pageQuery.time"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="-"
          start-placeholder="选择日期"
          end-placeholder="选择日期"
          @change="$forceUpdate()"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh-left" @click="resetQuery"
          >重置</el-button
        >
        <el-button icon="el-icon-download" @click="handleExport"
          >导出数据</el-button
        >
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" element-loading-text="加载中" :data="list">
      <el-table-column label="序号" align="center" type="index" width="50" />
      <el-table-column label="消息内容" align="center" prop="msgContent"></el-table-column>
      <el-table-column
        label="接收人"
        align="center"
        prop="userName"
      ></el-table-column>
      <el-table-column label="接收账号" align="center" prop="mobile" />
      <el-table-column label="发送时间" align="center" prop="createTime" />
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageQuery.pageNum"
      :limit.sync="pageQuery.pageSize"
      @pagination="getMessagePageList"
    />
  </div>
</template>

<script>
import { messagePageList } from "@/api/sportManage/basic";
export default {
  name: "list",
  data() {
    return {
      pageQuery: {
        pageNum: 1,
        pageSize: 10,
        time: [],
      },
      loading: false,
      total: 0,
      list: [],
    };
  },
  created() {
    this.getMessagePageList();
  },
  methods: {
    async getMessagePageList() {
      let res = await messagePageList({
        ...this.pageQuery,
      });
      if (res.code === 200) {
        this.list = res.data.list;
        this.total = res.data.total;
        console.log(res);
      }
    },
    handleQuery() {
      this.pageQuery.startTime = this.pageQuery.time
        ? this.pageQuery.time[0]
        : "";
      this.pageQuery.endTime = this.pageQuery.time
        ? this.pageQuery.time[1]
        : "";
      this.pageQuery.pageNum = 1;
      this.getMessagePageList();
    },
    resetQuery() {
      this.$refs["queryForm"].resetFields();
      this.pageQuery.startTime = "";
      this.pageQuery.endTime = "";
      this.getMessagePageList();
    },

    handleExport() {
      this.download(
        "/biz/message/export",
        {
          ...this.pageQuery,
        },
        `消息列表` + new Date().getTime() + `.xlsx`
      );
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/styles/common.scss";
</style>
